var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "xueShengZongHeShiXun" }, [
    _c(
      "div",
      {
        staticClass: "student_training_left",
        style: "height:" + (_vm.height - 90) + "px"
      },
      [
        _c("div", { staticClass: "encourage_words" }, [
          _c("p", [
            _vm._v(
              _vm._s(_vm.famousQuotesData.content) +
                "—" +
                _vm._s(_vm.famousQuotesData.author)
            )
          ])
        ]),
        _vm._v(" "),
        false
          ? _c("div", { staticClass: "course_task_progress" }, [
              _c("h2", [
                _vm._v("课程任务进度"),
                _c("span", [
                  _vm._v("完成任务"),
                  _c("i", [
                    _vm._v(_vm._s(_vm.taskProgressData.finishTaskNum) + "个")
                  ]),
                  _vm._v("/ 总任务"),
                  _c("i", [
                    _vm._v(_vm._s(_vm.taskProgressData.totalTaskNum) + "个")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "course_task_progress_left" },
                [
                  _c("el-progress", {
                    attrs: {
                      "stroke-width": 7,
                      percentage: _vm.taskProgressData.progress
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "course_task_progress_right" }, [
                _c("p", [
                  _c("span", [
                    _c("i", [_vm._v(_vm._s(_vm.taskProgressData.sort))]),
                    _vm._v("/" + _vm._s(_vm.taskProgressData.studentNum))
                  ]),
                  _vm._v("班级排名")
                ]),
                _vm._v(" "),
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/study/statistics/ranking.png"),
                    alt: ""
                  }
                })
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "post_statistics" }, [
          _c("h2", [_vm._v("分岗位正确率统计")]),
          _vm._v(" "),
          _vm.postAccuracyStatisticsData.length > 0
            ? _c(
                "ul",
                _vm._l(_vm.postAccuracyStatisticsData, function(item, i) {
                  return _c(
                    "li",
                    { key: i },
                    [
                      _c("el-progress", {
                        attrs: {
                          type: "circle",
                          percentage: item.rate
                            ? Math.ceil(item.rate * 100)
                            : 0,
                          color: _vm.postAccuracyColor[i]
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          _vm._s(item.postName) +
                            "(" +
                            _vm._s(item.userName) +
                            ")"
                        )
                      ])
                    ],
                    1
                  )
                }),
                0
              )
            : _c("div", { staticClass: "no_data" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/wujieguo.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v("暂无统计结果")])
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "group_comprehensive_strength" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm.groupComprehensiveStrength.length > 0
            ? _c(
                "ul",
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._l(_vm.groupComprehensiveStrength, function(item, i) {
                    return _c("li", { key: i }, [
                      _c("div", [
                        i == 0
                          ? _c("img", {
                              attrs: {
                                src: require("../../../../../../../static/images/study/statistics/first.png"),
                                alt: ""
                              }
                            })
                          : i == 1
                          ? _c("img", {
                              attrs: {
                                src: require("../../../../../../../static/images/study/statistics/second.png"),
                                alt: ""
                              }
                            })
                          : i == 2
                          ? _c("img", {
                              attrs: {
                                src: require("../../../../../../../static/images/study/statistics/thrid.png"),
                                alt: ""
                              }
                            })
                          : _c("span", [_vm._v(_vm._s(i + 1))])
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(_vm._s(item.teamName)),
                        _vm.teamId == item.teamId
                          ? _c("span", { staticStyle: { color: "#FD785A" } }, [
                              _vm._v("(我的)")
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(item.rate))]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(item.teamUserNames))]),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(item.teamTitle))])
                    ])
                  })
                ],
                2
              )
            : _c("div", { staticClass: "no_data" }, [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/wujieguo.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("p", [_vm._v("暂无统计结果")])
              ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "notes_and_discuss" }, [
          _c("div", { staticClass: "notes_wrap" }, [
            _c("h2", [_vm._v("笔记")]),
            _vm._v(" "),
            _c("div", { staticClass: "note_details" }, [
              _c("img", {
                attrs: {
                  src: require("../../../../../../../static/images/study/statistics/note.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("div", [
                _c("b", [_vm._v(_vm._s(_vm.noteData.noteNum) + "条")]),
                _vm._v(" "),
                _c("p", [_vm._v("公开笔记数")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "discuss_wrap" }, [
            _c("h2", [_vm._v("讨论")]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/study/statistics/theme.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v(_vm._s(_vm.discussData.themeNum) + "条")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("发表主题数")])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/study/statistics/reply.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v(_vm._s(_vm.discussData.replyNum) + "条")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("回复主题数")])
                ])
              ]),
              _vm._v(" "),
              _c("li", [
                _c("img", {
                  attrs: {
                    src: require("../../../../../../../static/images/study/statistics/comment.png"),
                    alt: ""
                  }
                }),
                _vm._v(" "),
                _c("div", [
                  _c("b", [_vm._v(_vm._s(_vm.discussData.commentNum) + "条")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("发表评论数")])
                ])
              ])
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    false
      ? _c(
          "div",
          {
            staticClass: "student_training_right",
            style: "height:" + (_vm.height - 90) + "px"
          },
          [
            _c("h2", [_vm._v("学习轨迹")]),
            _vm._v(" "),
            _vm.activities.length > 0
              ? _c(
                  "el-timeline",
                  { staticClass: "timeline_ul" },
                  _vm._l(_vm.activities, function(activity, index) {
                    return _c(
                      "el-timeline-item",
                      {
                        key: index,
                        attrs: {
                          icon: activity.icon,
                          type: activity.type,
                          color: activity.color,
                          size: activity.size,
                          timestamp: activity.timestamp,
                          placement: "top"
                        }
                      },
                      [
                        _c("div", { staticClass: "timeline_card" }, [
                          _c("p", [_vm._v(_vm._s(activity.content))]),
                          _vm._v(" "),
                          activity.type == "1"
                            ? _c("img", { attrs: { src: _vm.picture } })
                            : activity.type == "2"
                            ? _c("img", { attrs: { src: _vm.file } })
                            : activity.type == "3"
                            ? _c("img", { attrs: { src: _vm.audio } })
                            : activity.type == "4"
                            ? _c("img", { attrs: { src: _vm.video } })
                            : activity.type == "5"
                            ? _c("img", { attrs: { src: _vm.zip } })
                            : activity.type == "6"
                            ? _c("img", { attrs: { src: _vm.question } })
                            : activity.type == "7"
                            ? _c("img", { attrs: { src: _vm.paper } })
                            : activity.type == "8"
                            ? _c("img", { attrs: { src: _vm.file } })
                            : activity.type == "9"
                            ? _c("img", { attrs: { src: _vm.file } })
                            : activity.type == "10"
                            ? _c("img", { attrs: { src: _vm.file } })
                            : activity.type == "11"
                            ? _c("img", { attrs: { src: _vm.file } })
                            : _c("img", { attrs: { src: _vm.file } })
                        ])
                      ]
                    )
                  }),
                  1
                )
              : _c("div", { staticClass: "no_data" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../../../../../static/images/wujieguo.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("暂无学习轨迹")])
                ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _vm._v("组队综合实力最新排行榜\n          "),
      _c("span", { staticStyle: { "font-size": "13px", color: "red" } }, [
        _vm._v("(算法规则:取小组正确率和完成任务数作为综合统计指标)")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("div", [_vm._v("排行")]),
      _vm._v(" "),
      _c("div", [_vm._v("小组名称")]),
      _vm._v(" "),
      _c("div", [_vm._v("实力值")]),
      _vm._v(" "),
      _c("div", [_vm._v("小组成员")]),
      _vm._v(" "),
      _c("div", [_vm._v("小组标语")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5714d212", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5714d212","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/statistics/student/comprehensiveTraining.vue
// module id = null
// module chunks = 